// Internal modules
import { getGlobals } from './globals';
import { APP_NAME, FRAUD_NET_FIELD_LIST } from './constants';
import { getClientMetadataID } from './utils';

const filterPrefilledFields = (prefilledFields = []) => {
  return FRAUD_NET_FIELD_LIST.filter(({ id }) => !prefilledFields.includes(id));
};

const getFraudNetConfig = prefilledFields => {
  const { uri } = getGlobals();

  return {
    endpoint: uri.fraudNetEndpoint,

    sourceId: APP_NAME,

    typingSpeed: {
      /**
       * Allows for FraudNet to track dynamically rendered fields by delegating
       * the event listener to the body instead of attaching it to individual
       * fields.
       */
      delegate: true,

      /**
       * List of required fields that can be rendered. This list should include
       * all fields that are required for only certain flows, e.g. fields that
       * are only rendered in certain situations. We filter out pre-filled
       * fields so that FraudNet doesn't mistakenly tag them as suspicious due
       * to being programmatically filled.
       */
      fields: filterPrefilledFields(prefilledFields),

      // Should be the same as `sourceId`
      type: APP_NAME,
    },

    userToken: getClientMetadataID(),
  };
};

export { getFraudNetConfig };
